import { FC } from 'react';
import { cn } from '../../../../utils/cn';
import { statusStyles, type AppointmentStatus } from './types';

const STATUSES: AppointmentStatus[] = ['confirmed', 'completed', 'cancelled', 'pending'];

export const StatusLegend: FC = () => {
  return (
    <div className="flex flex-wrap gap-4 text-sm">
      {STATUSES.map((status) => {
        const style = statusStyles[status];
        return (
          <div key={status} className="flex items-center gap-2">
            <div
              className={cn('w-3 h-3 rounded-full', style.bg, style.darkBg, 'border', style.border)}
            />
            <span className="text-gray-600 dark:text-slate-400">{style.label}</span>
          </div>
        );
      })}
    </div>
  );
};
